import func, { isEmpty } from "./functions";

export const tinTypes = [
    { label: "NUIS", value: "1" },
    { label: "ID", value: "2" },
    { label: "PASS", value: "3" },
    { label: "VAT", value: "4" },
    { label: "TAX", value: "5" },
    { label: "SOC", value: "6" },
];

export const defaultTableRows ={
  totalRows: 0,
  rowsPerPage: 10,
  currentPage: 1,
}

export const myinvoiceTypes = [
  { value:"badDebt",label:"Bad Debt" },
  { value:"reverse",label:"Reverse" },
  { value:"selfInvoice",label:"Self Invoice"},
  { value:"summary",label:"Summary"}
]

export const paymentOptions=[
    {
      value:"NONCASH",
      label:"Non Cash"
    },
    {
      value:"CASH",
      label:"Cash"
    },
  ]

export const subscriptionStatus={
  active:"1",
  upcoming:"2",
  expired:"4",
  canceled:"3",
  suspended:"5"

}


export const partiesDialogTypes={
  seller:"SELLER",
  buyer:"BUYER"
}


export const getTcrList=(company,showNoneOption=true)=>{
  let tcrList = [];

    (company?.branches ?? [])
    .reduce(
        (acc, branch) =>
            branch?.tcrTypes?.length > 0 ? acc.concat(branch.tcrTypes) : acc,
        []
    )
    .forEach((tcr) => {
        if (tcr?.allowPurchase) {
            let sellerName =
                company?.branches?.find(
                    (branch) => branch?.businUnitCode == tcr?.businUnitCode
                )?.sellerName ?? "";
            tcrList.push({
                label: tcr.tcrCode + " - " + sellerName,
                value: tcr.tcrCode,
            });
        }
    });
  return tcrList.length > 0 && showNoneOption
    ? [{ label: "Select", value: null }].concat(tcrList)
    : tcrList;
}


export const validateTransportInvoice = ({setErrors, state,t }) => {

  const validationErrors = {};

  const nuisValidation=(nuis)=>{
    const test=!(/[A-Za-z][0-9Oo]{8}[A-Za-z]$/.test(nuis))
    return test
  }

  const validateFields = [
    { value: "code", label: "Code" },
    { value: "name", label: "Name" },
    { value: "unitOfMeasure", label: "Unit of measure" },
    { value: "quantity", label: "Quantity" },
    { value: "packNum", label: "Pack num" },
    { value: "vehicle.vehiclePlate", label: "Vehicle plate" },
    { value: "valueOfGoods", label: "Value of goods" },
    { value: "parties.transporter.name", label: "Name" },
    { value: "parties.transporter.town", label: "Town" },
    { value: "parties.transporter.address", label: "Address" },
    { value: "parties.address.0.address", label: "Address" },
    { value: "address.0.address", label: "Address" },
    { value: "address.1.address", label: "Address" },
    { value: "address.0.date", label: "Address" },
    { value: "address.1.date", label: "Address" },
    { value: "parties.transporter.idNum", label: t("toast.incorrectNipt"),validation:nuisValidation },
    { value: "parties.buyer.name", label: t("toast.incorrectNipt") },
    { value: "parties.buyer.address", label: t("toast.incorrectNipt") },
    { value: "parties.buyer.town", label: t("toast.incorrectNipt") },
  ];

 
  validateFields.forEach((valid) => {
    const label = `${valid?.label} is Required`;
    if (valid.validation ? valid.validation(func.getNestedValue(state, valid.value)) :isEmpty(func.getNestedValue(state, valid.value)))
      validationErrors[valid?.value] = valid.validation ? valid.label:label;
  });

  setErrors(validationErrors);
  if(Object.keys(validationErrors).length > 0) return true
  return false
}


export const contactTypesFn=(t)=>[
  { type: "SUPPLIER", label: t("mySuppliers.supplier") },
  { type: "CUSTOMER", label: t("mySuppliers.customer") },
  { type: "EMPLOYEE", label: t("mySuppliers.employee") },
]
